let server = "https://vtbgfslh0k.execute-api.us-east-1.amazonaws.com/prod"
module.exports = server
